import { useEffect, useState,useContext } from "react"
import Spinner from 'react-bootstrap/Spinner';
import $ from "jquery";
import {
  useNavigate
} from "react-router-dom";
import UserContext from "../../contexts/UserContext";

const ViewPayment = () => {
    const navigate = useNavigate();
    const [payments,setPayments] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const {user,setUser} = useContext(UserContext);

    async function getData(userId){
      await $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : function(response){
          if(response && response.user){
             setUser(response.user);
          }else{
            setUser(null)
            navigate("/login",{state: { message: response.message }})
          }
  
        },
        error: function(err){
            console.log("error")
            console.log(err)
        }
    })
    }

  useEffect(()=>{
      try{
      if(!user && localStorage.getItem('userSession')){
        getData(JSON.parse(localStorage.getItem('userSession')))
      }else{
        if(!user){
          navigate("/login")
        }
      }
    }catch(e){
      if(!user){
        navigate("/login")
      }
    }
    },[])

    function getPayments(){
        $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/payments",
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success : function(response){
            setPayments(response)
            setLoading(false)
          },
          error: function(err){
              console.log("error")
              console.log(err)
              navigate("/login")
          }
        })
      }

    const PaymentCard = ({info}) => {
      const design = (
        <>
          <div className="compact-payment-card">
            <div className="user-info">
              <div className="user-name">{info.userInfo.name.toLowerCase()} ( {info.userInfo.hof} / {info.userInfo.sabeel} )</div>
            </div>
            <div className="payment-details">
              <div className="info-item">
                <span className="info-label">Date:</span>
                <span className="info-value">{info.date}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Type:</span>
                <span className="info-value">{info.paymentType}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Ref #:</span>
                <span className="info-value">{info.refNumber}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Amount:</span>
                <span className="info-value">INR {info.amount}</span>
              </div>
              {
                    info.comments && info.comments.length>0?
                    <div className="info-item">
                    <span className="info-label">Comments:</span>
                    <span className="info-value">{info.comments}</span>
                    </div>:
                    null
                }
            </div>
          </div>
        </>
      )
      return design;
    }  

    useEffect(()=>{
        getPayments();
    },[])  

    const design = (
        <>
        {
          payments.length>0?
          payments.map((payment) => {
            return <PaymentCard info={payment} />
          })
          :
          <p style={{color:'red',margin:'10px'}}>No Payment Info !</p>
        }
            
        </>
    )
    return isLoading? <div className="mx-auto mt-5" style={{width: "30px"}}><Spinner className="mx-auto " style={{color:'brown'}} animation="border" role="status">
    </Spinner><br/>
    <span style={{marginLeft:'-10px'}}>Loading...</span></div>: design;
}

export default ViewPayment;